import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AllService } from '../rest/all.service';


@Component({
  selector: 'app-callback',
  providers: [AllService],
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit {

  loginToken: string = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private services: AllService
  ) { }

  ngOnInit() {

    this.route.paramMap.subscribe(async params => {

      if (params.has("lt")) {

        this.loginToken = '' + params.get("lt");
        localStorage.setItem('key', this.loginToken);

        var LoginResponse = await this.services.getJWTToken(this.loginToken).then(result=> {
            
          if (result.code == 1){
              //console.log('Bearer', result.message);
              localStorage.setItem('Bearer', result.message);
              const redirect = '/Indicators';
              this.router.navigate([redirect]);
            }    

        });

      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/callback/callback.component.ts